import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PCMP_PROJECT_ACTIVE_FILTER } from '@/features/pcmp/constants/pcmpProject.constants';
import { PcmpProjectsListPage } from '@/features/pcmp/pages/PcmpProjectsListPage';

const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

export const pcmpProjectsListSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
  edition: z.number().int().positive().optional().catch(undefined),
  company: z.number().int().positive().optional().catch(undefined),
  state: z.enum(PCMP_PROJECT_ACTIVE_FILTER).optional().catch(undefined),
  from: z.string().regex(DATE_ONLY_RE).optional().catch(undefined),
  to: z.string().regex(DATE_ONLY_RE).optional().catch(undefined),
});

export type PcmpProjectsListSearch = z.infer<typeof pcmpProjectsListSearchSchema>;

export const Route = createFileRoute('/_auth/pcmp/projects/')({
  validateSearch: pcmpProjectsListSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Projects">
      <Suspense fallback={<PageLoader />}>
        <PcmpProjectsListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
